import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Counter } from '../../shared/components/counter/counter';
import { TodoComponent } from '../todos/todo/todo-component/todo-component';
import { LoggerService } from '../../shared/logger.service';
import { CounterService } from '../../shared/counter-service';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { SearchDebounced } from '../../shared/components/search-debounced/search-debounced';
import { Ticker } from '../../shared/components/ticker/ticker';

@Component({
  selector: 'casi-test-page',
  imports: [
    CommonModule,
    FormsModule,
    FontAwesomeModule,
    Counter,
    TodoComponent,
    SearchDebounced,
    Ticker
  ],
  templateUrl: './test-page.html',
  styleUrl: './test-page.scss'
})
export class TestPage {

  counter = 10;

  cnt = signal(0);
  derivedCnt = computed(() => {
    return this.cnt() * 10;
  });

  constructor(
    public faIcons: FaIconLibrary,
    private logger: LoggerService,
    public counterService: CounterService
  ) {
    faIcons.addIcons(...all);
    this.logger.debug(`cnt: ${this.cnt()}`);
  }

  onIncrement() {
    this.counter++;
  }

  increment() {
    this.logger.debug(`increment counter...`);
    // this.cnt.set(this.cnt() + 1);
    this.cnt.update(c => c + 1);
    this.counterService.incrementCounter();
  }

}
